var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.rule
    ? _c("div", { staticClass: "category-discount-progress" }, [
        _c("b", { staticClass: "category-discount-progress__title" }, [
          _vm._v(
            _vm._s(
              _vm.$translate("OD3dprimaV2::Template.categoryDiscountTitle")
            )
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "category-discount-progress__bar" },
          [
            _c("div", {
              staticClass:
                "category-discount-progress__fill category-discount-progress__fill--cart",
              style: { width: _vm.cartPercent + "%" },
            }),
            _vm._v(" "),
            _c("div", {
              staticClass:
                "category-discount-progress__fill category-discount-progress__fill--adding",
              style: {
                left: _vm.cartPercent + "%",
                width: _vm.addingPercent + "%",
              },
            }),
            _vm._v(" "),
            _vm._l(_vm.rule.tiers, function (tier, index) {
              return _c("div", {
                key: index,
                staticClass: "category-discount-progress__marker",
                class: {
                  "category-discount-progress__marker--reached":
                    _vm.total >= tier.minQty,
                },
                style: { left: _vm.positionOf(tier.minQty) + "%" },
              })
            }),
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "category-discount-progress__labels" },
          _vm._l(_vm.rule.tiers, function (tier, index) {
            return _c(
              "span",
              {
                key: index,
                staticClass: "category-discount-progress__label",
                class: {
                  "category-discount-progress__label--reached":
                    _vm.total >= tier.minQty,
                },
                style: { left: _vm.positionOf(tier.minQty) + "%" },
              },
              [
                _c("b", [_vm._v(_vm._s(tier.percent) + " %")]),
                _vm._v(" "),
                _c("small", [
                  _vm._v(
                    _vm._s(
                      _vm.$translate(
                        "OD3dprimaV2::Template.categoryDiscountQty",
                        { qty: tier.minQty }
                      )
                    )
                  ),
                ]),
              ]
            )
          }),
          0
        ),
        _vm._v(" "),
        _c("div", { staticClass: "category-discount-progress__footer" }, [
          _c(
            "small",
            { staticClass: "category-discount-progress__text" },
            [
              _vm.unlockedTier
                ? _c(
                    "b",
                    { staticClass: "category-discount-progress__unlock" },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.$translate(
                              "OD3dprimaV2::Template.categoryDiscountProgressUnlock",
                              { percent: _vm.unlockedTier.percent }
                            )
                          ) +
                          "\n            "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.nextTier
                ? [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$translate(
                            "OD3dprimaV2::Template.categoryDiscountProgressNext",
                            {
                              qty: _vm.nextTier.minQty - _vm.total,
                              percent: _vm.nextTier.percent,
                            }
                          )
                        ) +
                        "\n            "
                    ),
                  ]
                : !_vm.unlockedTier
                ? [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$translate(
                            "OD3dprimaV2::Template.categoryDiscountProgressMax",
                            { percent: _vm.reachedTier.percent }
                          )
                        ) +
                        "\n            "
                    ),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.inCart > 0
                ? _c(
                    "span",
                    { staticClass: "category-discount-progress__in-cart" },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.$translate(
                              "OD3dprimaV2::Template.categoryDiscountProgressInCart",
                              { count: _vm.inCart }
                            )
                          ) +
                          "\n            "
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _c("small", { staticClass: "category-discount-progress__hint" }, [
            _vm._v(
              _vm._s(
                _vm.$translate("OD3dprimaV2::Template.categoryDiscountHint")
              )
            ),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }